module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg33.ed00f5b9.jpg";